export default __webpack_public_path__ + "static/media/seth.36969fe7.png";